import {Spinner} from '@primer/react'

import {clsx} from 'clsx'

import styles from './CenteredLoadingSpinner.module.css'

export function CenteredLoadingSpinner({className}: {className?: string}): React.ReactElement {
  return (
    <div className={clsx(styles.SpinnerContainer, className)}>
      <Spinner />
    </div>
  )
}
